module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DT3Ltf/cover.jpeg?1684514559203",
      "alt": "This image is the cover for the book Peerless King of Medicine, Book 12"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Peerless King of Medicine, Book 12\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the previous life, he was very weak, and he roved from his childhood. Later, he was adopted by her family. They grew up together and fell in love. But one day, when the disaster came, he watched all those people he loved died one by one but could not do anything about it.Sad and angry, he practiced for thousands of years and then reborn to acompany his beloved. In this life, he had superb abilities and had become a medicine king that others couldn't reach. His only goal was to protect the one he loves deeply, but， she doesn't know that he is the lover of the previous life. Could their love be as sweet as ever? Could they return to those carefree days?Once weak and lost too much, but now? No one dares to take away all this good!☆About the Author☆Bing Feng Tian Xia, an excellent online novelist who has created many novels. Most of his novels are fantasy types. His masterpieces are: Peerless Emperor Dan, Martial Emperor in the Holy Land, and so on.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frozen Worlds, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0